// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".campaigns-edit-step-social-menu[data-v-6658a942]{background:#f2f3f6}", ""]);
// Exports
module.exports = exports;
